import { randomAlphaNumString } from '@kit/utils/Formats'

/////////////////////////////////////////////////////////////////////////////
//
// Basic stack/flush utility to handle all those aria labelled-by situations
//
////////////////////////////////////////////////////////////////////////////

class _AriaID {

 constructor() {

  this._idKVP = {}
  
 }

 /**
  * This will return an id or set of ids, and make those ids available for
  * future elements to consum
  * 
  * @param {*} key optional.
  * @param {*} num optional. defaults to 1.
  * @param {*} shared optional. If true, then this will make the same id and push it a multiple
  *   number of times and this is handy for situation where you have a single gallery image which is
  *   controlled by a bunch of buttons and they all need to say that they control the same element.
  * 
  
  This will make a comma separated list of ids the for the aria-labelledby.
  Those ids will be attached to objects that will exist further down in the markup, i.e. in the future.
 
    <input type="text" :aria-labelledby="aria.futureID(2)"/>
    <span class="error" :id="aria.id()">Error</span>
    <span class="info" :id="aria.id()">Click for info</span>

  */
  futureID(num, key, shared) {
    const _key = key || "_"
    const _num = num || 1

    let slot = this._idKVP[_key]
    if(!slot) {
      slot = []
      this._idKVP[_key] = slot
    }

    const sharedID = shared ? randomAlphaNumString(15) : null

    for(let i=0; i<_num; i++) {
      const id = sharedID || randomAlphaNumString(15)
      slot.push(id)
    }

    return slot.length > 1 ? slot.join(",") : slot[0]
  }


 /**
  * This will return an id or set of ids, and make those ids available for
  * future elements to consum
  * 
  * @param {*} key optional.
  * @param {*} num optional. defaults to 1.
  * 
  
  This will make a comma separated list of ids the for the aria-labelledby.
  Those ids will be attached to objects that will exist further down in the markup, i.e. in the future.

    <span class="error" :id="aria.id()">Error</span>
    <span class="info" :id="aria.id()">Click for info</span>
    <input type="text" :aria-labelledby="aria.pastID()"/>

  */
  pastID(key) {
    const _key = key || "_"

    let slot = this._idKVP[_key]
    if(!slot) {
      slot = []
      this._idKVP[_key] = slot
    }

    const list = slot.join(",")
    this._idKVP[_key] = []

    return list
  }


  id(key) {
    const _key = key || "_"
    let slot = this._idKVP[_key]

    if(!slot) {
      slot = []
      this._idKVP[_key] = slot
    }

    const ids  = slot

    //if there's already ids in here, then they're from the past
    //and we can just grab them and pop them off one at a time
    if(ids.length > 0) {
      return ids.pop()
    } 
    
    //Else, they're ids that don't exist yet, so make one, 
    //stack it and then pass it along
    else {
      const newID = randomAlphaNumString(15)
      ids.push(newID)
      return newID
    }
  }

  flush(key) {
    const _key = key || "_"
    this._idKVP[_key] = null 
    this._idKVP[_key] = []
  }
}

export const AriaID = _AriaID

export const getRandomID = () => {
  return randomAlphaNumString(15)
}

